import { render, staticRenderFns } from "./TableBusiness.vue?vue&type=template&id=ebaa26f0&scoped=true"
import script from "./TableBusiness.vue?vue&type=script&lang=js"
export * from "./TableBusiness.vue?vue&type=script&lang=js"
import style0 from "./TableBusiness.vue?vue&type=style&index=0&id=ebaa26f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaa26f0",
  null
  
)

export default component.exports